import { useState } from 'react';
import Aside from './aside';
import './layout.css';
import Topbar from './topbar';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="layout">

      <Aside isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div className="main">
        <Topbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="content">
          {children}
        </div>
      </div>

    </div>
  );
}

export default Layout;